import { ParticipantDecoration } from '@src/components/PersonCard/ParticipantDecoration';
import './PolicyPage.css';
import { PageContent, Panel, Shell } from '@src/components';
import { PolicyCom } from '@src/pages/PolicyPage/PolicyCom';
import { PolicyRu } from '@src/pages/PolicyPage/PolicyRu';
import { isDotCom } from '@src/site';

/**
 * Host-specific legal text — the .com and .ru documents are different
 * policies, not translations of each other. .com never shows the Russian one.
 */
export function PolicyPage() {
  const com = isDotCom();

  return (
    <Shell>
      <PageContent testId="policy">
        <Panel elevated wide edges={{ pieces: 3 }} testId="policy-panel" className="policy-panel">
          <div className="policy-panel__decorations" aria-hidden="true">
            <ParticipantDecoration variant="crystals" />
            <ParticipantDecoration variant="sparkles" />
            <ParticipantDecoration variant="seasonal" />
          </div>
          {com ? <PolicyCom /> : <PolicyRu />}
        </Panel>
      </PageContent>
    </Shell>
  );
}
